export enum ConsumptionAlertTileTexts {
    TITLE = 'Verbrauchsalarm',
    LABEL_MAX_LAST_7_DAYS = 'Maximum der letzten 7 Tage',
}
